module.exports = __webpack_public_path__ + "static/media/fenster_zu.df0c0fba.jpg";